export default "<p>\r\n  stats works!\r\n</p>\r\n";